<template>
  <div class="banner">
    <div class="container">
      <div class="row hidden-xs-down">
        <div class="col-md-4">
          <h1 class="logo"><img src="../assets/logo_luna.png" alt="Laboratório da Luna" /></h1>
        </div>
        <div class="col-md-8">
          <div class="download hidden-md-down">
            <strong class="call-soon">A melhor experiência de todas já está nas lojas</strong>
            <a href="https://apple.co/2HiipHl" target="_blank">
              <img src="../assets/btn-appStore.svg" class="store-button" />
            </a>
            <a href="http://bit.ly/2HiGtcZ" target="_blank">
              <img src="../assets/btn-googleplay.png" class="store-button" />
            </a>
          </div>
        </div>
      </div>
      <div class="video-wrapper">
        <iframe
          class="video"
          src="https://player.vimeo.com/video/254011750?autoplay=0&color=F26722&title=0&byline=0&portrait=0"
          frameborder="0"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen>
        </iframe>
      </div>
      <div class="character character-luna"></div>
      <div class="character character-claudio"></div>
      <div class="character character-jupiter"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'banner',
}
</script>

<style scoped>
.banner {
  background: #F26722;
  background-size: cover;
  font-size: 19px;
}


@media (max-width: 575px) {
  .container {
    padding: 0;
  }
}

@media (min-width: 576px) {
  .banner {
    background: #FFFDE4 url(../assets/background.png) no-repeat center center;
    padding: 1.2rem 0 2.4rem;
  }
}

.logo {
  margin-bottom: 0.6em;
}

.logo img {
  width: 174px;
  height: 117px;
}

.download {
  text-align: right;
}

.call-soon {
  font-family: 'SC Gum Kids';
  font-weight: normal;
  font-style: normal;
  color: #F26722;
  display: block;
  font-size: 1.4em;

}

.store-button {
  width: 228px;
}

.video-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
}

.video {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.character {
  position: absolute;
  background: no-repeat center center;
  background-size: contain;
  bottom: 0;
  display: none;
}

.character-claudio {
  width: 179px;
  height: 230px;
  right: -179px;
  /* offset */
  margin-bottom: -12px;
  margin-right: 14px;
  background-image: url(../assets/claudio.png);
}

.character-luna {
  width: 382px;
  height: 593px;
  right: -382px;
  background-image: url(../assets/luna.png);
}

.character-jupiter {
  width: 320px;
  height: 294px;
  /* offset */
  left: -320px;
  background-image: url(../assets/jupiter.png);
}

@media (min-width: 1500px) {
  .character-claudio {
    display: block;
  }
}

@media (min-width: 1900px) {
  .character-jupiter,
  .character-claudio,
  .character-luna {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// Banner.vue?3092c9d6